import React from "react";
import CredentialPicker from "../../../../auth/CredentialPicker";
import WizardBasicAuth from "./WizardBasicAuth";
import { CredentialsType } from "../../../../common/interfaces/credentials/Credentials";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentWizardData } from "../../../../redux/actions/wizardActions";
import { Flex } from "@atlaskit/primitives";
import SectionMessage from "@atlaskit/section-message";

const NewOrExistingAuth = ({ info }) => {
  const currentData = useSelector((state) => state.wizard.currentData);
  const dispatch = useDispatch();

  // Function to handle radio button change
  const handleRadioChange = (e) => {
    const updatedData = {
      ...currentData,
      selectedAuthOption: e.target.value,
    };
    dispatch(setCurrentWizardData(updatedData));
  };

  // Function to update Redux state based on the selected option
  const onChangeCredentialPicker = (value) => {
    const updatedData = {
      ...currentData,
      credential: value,
    };
    dispatch(setCurrentWizardData(updatedData));
  };

  return (
    <div>
      <br />
      <SectionMessage title="Information" appearance="info">
        <p>{info}</p>
      </SectionMessage>
      <br />
      <Flex gap="space.100" justifyContent={100}>
        <div>
          <label>
            <input
              type="radio"
              value="CredentialPicker"
              checked={currentData?.selectedAuthOption === "CredentialPicker"}
              onChange={handleRadioChange}
            />
            Existing Credential
          </label>
          <br />
          <label>
            <input
              type="radio"
              value="WizardBasicAuth"
              checked={currentData?.selectedAuthOption === "WizardBasicAuth"}
              onChange={handleRadioChange}
            />
            New Credential
          </label>
        </div>
        <div className="wizard-basic-cred">
          {(currentData?.selectedAuthOption === "CredentialPicker" ||
            !currentData?.selectedAuthOption) && (
            <>
              Stored Credentials:
              <CredentialPicker
                onSelect={onChangeCredentialPicker}
                value={currentData?.credential?.value}
                showOnlyCredType={CredentialsType.BASIC_AUTH}
              />
              Select a stored Jira PAT token credential.
            </>
          )}
          {currentData?.selectedAuthOption === "WizardBasicAuth" && (
            <WizardBasicAuth />
          )}
        </div>
      </Flex>
    </div>
  );
};

export default NewOrExistingAuth;
